export enum GrapSettingsEnums {
	ShippingTime = 'firstmile_co_pickup_time',
	ToApollo = 'firstmile_co_send_order_apollo',
	Interval = 'delivery/timeslots/interval',
	NDay = 'delivery/timeslots/nDay',
}
